import { render, staticRenderFns } from "./ReportTabBusinessTerm.vue?vue&type=template&id=d4dd8f1e&scoped=true&lang=pug"
import script from "./ReportTabBusinessTerm.vue?vue&type=script&lang=js"
export * from "./ReportTabBusinessTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dd8f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4dd8f1e')) {
      api.createRecord('d4dd8f1e', component.options)
    } else {
      api.reload('d4dd8f1e', component.options)
    }
    module.hot.accept("./ReportTabBusinessTerm.vue?vue&type=template&id=d4dd8f1e&scoped=true&lang=pug", function () {
      api.rerender('d4dd8f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/ReportTabBusinessTerm.vue"
export default component.exports